var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 11,
  viewBox: "0 0 20 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.5.5H14.4l4.9,5-4.8,5H.6C.5,7.2.5,3.8.5.5Z",
  fill: "none",
  stroke: "#aaa",
  strokeMiterlimit: 10,
  strokeWidth: 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8,7.3a1.8,1.8,0,1,1,1.8-1.8,1.793,1.793,0,0,1-1.8,1.8Z",
  fill: "none",
  stroke: "#aaa",
  strokeWidth: 1
})));
export default SvgIconTag;